import { CourseStats } from '../../../typings/api/models';
import { getFetch } from '../fetch';

import { apiConfig } from '../config';

export function getCourseStats(courseId: number): Promise<CourseStats> {
    // @ts-ignore
    const { apiGetCourseStats } = apiConfig.getStaticUrls();

    return getFetch(`${apiGetCourseStats}${courseId}/`);
}
